import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { updateCacheByType } from "../../../graphql/GraphQlProvider";

export interface DeleteNoteData {
    deleteNote: boolean;
}

export interface DeleteNoteInput {
    id: number;
}

export const DeleteNoteMutation = gql`
    mutation deleteNote($id: Int!) {
        deleteNote(id: $id)
    }
`;

export const deleteNote = () =>
    useMutation<DeleteNoteData, DeleteNoteInput>(DeleteNoteMutation, {
        update: updateCacheByType("Note")
    });

export default deleteNote;
